<template>
  <div class="zakat-donation-form">
    <!-- Amount Display Section -->
    <div class="zakat-amount-section">
      <div class="amount-label">Zakat Amount</div>
      <div class="amount-display">
        <span class="currency-symbol">{{ getSymbol() }}</span>
        <span class="amount-value">{{ formatAmount(zakatAmount) }}</span>
      </div>
      <div class="amount-note">This amount is calculated based on your Zakat calculation</div>
    </div>

    <!-- Currency Selection (if multiple currencies supported) -->
    <div class="currency-section" v-if="show_currency_dropdown && currencies">
      <label class="currency-label">Currency</label>
      <div class="el-custom-select">
        <el-select class="w-100" v-model="store.currency" @change="onCurrencyChange">
          <el-option 
            v-for="(curr, key) in currencies" 
            :value="key" 
            :key="key" 
            :label="curr"
          >
            {{ curr }}
          </el-option>
        </el-select>
      </div>
    </div>

    <!-- Purpose Display -->
    <div class="purpose-section">
      <div class="purpose-label">Donation Purpose</div>
      <div class="purpose-value">Zakat</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useDonationFormsStore } from '../store';

const store = useDonationFormsStore();

const props = defineProps({
  zakatAmount: {
    type: Number,
    required: true,
    default: 0
  },
  currencies: {
    type: Object,
    default: () => ({})
  },
  symbols: {
    type: Object,
    default: () => ({})
  },
  symbol: {
    type: String,
    default: '$'
  },
  show_currency_dropdown: {
    type: Boolean,
    default: false
  }
});

const lifeline_donation = globalThis.lifeline_donation;
const _ = globalThis._;

const getSymbol = () => {
  return (props.symbols[store.currency] != undefined) ? props.symbols[store.currency] : props.symbol;
};

const convert = (amt) => {
  const { exchange_rates } = lifeline_donation || {};
  const syb = getSymbol();
  if(_.get && _.get(exchange_rates, syb)) {
    return (_.get(exchange_rates, syb) * amt);
  }
  return amt;
};

const formatAmount = (amount) => {
  const convertedAmount = convert(amount);
  return parseFloat(convertedAmount).toFixed(2);
};

const onCurrencyChange = () => {
  // Handle currency conversion if needed
  console.log('Currency changed to:', store.currency);
};

// Set the zakat amount in the store
store.amount = props.zakatAmount;
store.extras.donation_purpose = 'Zakat';
</script>

<style scoped>
.zakat-donation-form {
  max-width: 400px;
  margin: 0 auto;
}

.zakat-amount-section {
  text-align: center;
  padding: 24px;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-radius: 12px;
  margin-bottom: 20px;
  border: 2px solid #28a745;
}

.amount-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 500;
}

.amount-display {
  font-size: 36px;
  font-weight: bold;
  color: #28a745;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.currency-symbol {
  font-size: 28px;
}

.amount-value {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.amount-note {
  font-size: 12px;
  color: #888;
  font-style: italic;
}

.currency-section {
  margin-bottom: 20px;
}

.currency-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.el-custom-select {
  width: 100%;
}

.purpose-section {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  border-left: 4px solid #28a745;
}

.purpose-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.purpose-value {
  font-size: 16px;
  font-weight: 600;
  color: #28a745;
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .amount-display {
    font-size: 28px;
  }
  
  .currency-symbol {
    font-size: 22px;
  }
  
  .zakat-amount-section {
    padding: 20px 16px;
  }
}
</style>